export default __webpack_public_path__ + "static/media/patriciagames.c53dc9c5.svg";